import rootAxios from './rootAxios';

export class TrainingRequests {
  static async getUsersbasedOnRegion({ region, skip = 0, limit = 100 }) {
    // this api shall give all employees who have joined recently based on trainers region.
    // to identifytrainer the userID is being passes in headers defined in rootAxios instance.

    const response = await rootAxios.post(
      `/user/getLastestEmployees`,
      { batchId: 'batch1stDemo' }, // Payload (body)
      {
        params: {
          skip: skip,
          limit: limit,
        },
      }
    );

    return response.data.data.employees;
  }
  static async searchEmployees(search) {
    if (search.trim().length > 0) {
      try {
        const data = { searchString: search };
        const response = await rootAxios.post('/super-user/getTrainingEmployee', data);
        if (response) {
          return response?.data?.data?.employee;
        }
      } catch (error) {
        //console.error(error);
        return [];
      }
    } else {
      return [];
    }
  }

  static async createTrainee(payload) {
    try {
      const response = await rootAxios.post('/super-user/createTrainer', {
        data: payload,
      });
      if (response) {
        return response?.data?.data?.employee;
      }
    } catch (error) {
      //console.error(error);
      return [];
    }
  }

  static async updateTrainee(payload) {
    await this.createTrainee(payload);
  }

  static async createTrainingType(payload) {
    try {
      const response = await rootAxios.post('/super-user/create-training-types', {
        data: payload,
      });
      if (response) {
        return response?.data?.data;
      }
    } catch (error) {
      //console.error(error);
      return [];
    }
  }

  static async updateTrainingType(payload) {
    try {
      const response = await rootAxios.put('/super-user/create-training-types', {
        data: payload,
      });
      if (response) {
        return response?.data?.data;
      }
    } catch (error) {
      //console.error(error);
      return [];
    }
  }

  static async getAllTrainers() {
    try {
      const response = await rootAxios.get(`/super-user/getTrainers`);
      return response?.data?.data?.trainers;
    } catch (e) {
      return [];
    }
  }

  static async changeTrainingType(batchId, newTrainingType, reason) {
    const response = await rootAxios.put(`/super-user/change-training-type`, {
      batchId,
      newTrainingType,
      reason,
    });
    return response?.data;
  }

  static async assignTrainerToExistingBatch(batchId, trainer, reason) {
    try {
      const response = await rootAxios.put(`/super-user/reassign-batch`, {
        data: {
          batchId,
          trainer,
          reason,
        },
      });
      return { status: true, message: response };
    } catch (e) {
      return { status: false, message: e };
    }
  }

  static async markAttendenceRequest(data) {
    const response = await rootAxios.put(`/super-user/create-attendance`, {
      data,
    });
    return response;
  }

  static async submitFeedback(data) {
    try {
      const response = await rootAxios.post(`/super-user/submit-training-feedback`, data, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response;
    } catch (e) {
      throw new Error(e.response?.data?.message || 'Failed to submit feedback');
    }
  }

  static async generateCertificates(batchId) {
    try {
      const response = await rootAxios.post('/super-user/generate-certificates', {
        batchId,
      });
      return response;
    } catch (e) {
      throw new Error(e.response?.data?.message || 'Failed to generate certificates');
    }
  }
  static async getAllClusterTrainers() {
    try {
      const response = await rootAxios.get(`/super-user/getClusterTrainers`);
      return response?.data?.data?.trainers;
    } catch (e) {
      return [];
    }
  }
}
